<template lang="pug">
    #companion-rating-card
      .card-title
        .level.custom-point
          .level-left
            .level-item
                p.m-2 Click the complete button to claim your 8 points
            .level-item
               WtButton.is-outlined(color="primary" size="medium") Completed
        .level.mb-2.mt-1.ml-3
            .level-left
                .level-item
                    p.m-2 Help us recommend more focused content for you by rating this {{ contentType }}
                .level-item
                   WtSvgIcon.mr-1(v-for="star in 5" :key="star" :icon="getStarIcon(star)" width="40px" height="40px" @click="rateContent(star)" :class="{ 'active': star <= currentRating }")
  </template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "CompanionRatingCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    contentType: { type: String, default: "" }
  },
  data() {
    return {
      currentRating: 0
    };
  },
  methods: {
    rateContent(rating) {
      // Update the current rating
      this.currentRating = rating;
      console.log("currentRating", this.currentRating);
      // You can send the rating to the server or perform any other action here
    },
    getStarIcon(star) {
      // Return different icons based on the current rating
      return star <= this.currentRating
        ? "companion/rating_star_filled_icon"
        : "companion/rating_star_icon";
    }
  }
};
</script>

<style lang="sass" scoped>
#companion-rating-card
  border: 1px solid #D9DBE0
  border-radius: 0.5rem
  background-color: #FBFBFB
  .custom-point
    margin: 0.50rem 0rem 0.25rem 0.75rem
    font-weight: 600 !important
  .button
    margin: 0 10px
    min-width: 100px
    border-radius: 9px
</style>
